/* eslint-disable no-undef */
import { parseCookies } from 'nookies'

const domain = process.env.VITTUDE_OFFLINE_URL
const currency = 'BRL'

const clearEcommerceObject = () => {
  typeof window !== undefined && window && window.dataLayer?.push({ ecommerce: null })
}
export const getSearchVariant = (variant) => {
  const cookies = parseCookies()
  const origin = cookies.searchOrigin
  const version = cookies.searchVersion

  const validVariants = ['v1', 'v2', 'nao-logado']
  const isBusca = origin === 'busca'
  const isVersionValid = version && validVariants.includes(version)

  const finalVariant = isBusca ? (isVersionValid ? version : 'nao-logado') : variant

  return finalVariant
}

export const sendViewItemListEvent = ({
  impressions,
  itemListId,
  itemListName,
  variant = 'PRINCIPAL'
}) => {
  clearEcommerceObject()

  dataLayer?.push({
    event: 'view_item_list',
    domain,
    ecommerce: {
      variant: getSearchVariant(variant),
      currencyCode: currency,
      item_list_id: itemListId,
      item_list_name: itemListName,
      impressions
    }
  })
}

export const sendSelectItemEvent = ({ professionalData, variant = 'PRINCIPAL' }) => {
  clearEcommerceObject()

  if (!Array.isArray(professionalData)) {
    professionalData = [professionalData]
  }

  dataLayer.push({
    event: 'select_item',
    domain,
    ecommerce: {
      variant: getSearchVariant(variant),
      items: professionalData
    }
  })
}

export const sendViewItemEvent = (professionalData, value, variant = 'PRINCIPAL') => {
  clearEcommerceObject()

  if (!Array.isArray(professionalData)) {
    professionalData = [professionalData]
  }

  dataLayer.push({
    event: 'view_item',
    domain,
    ecommerce: {
      variant: getSearchVariant(variant),
      currency,
      value,
      items: professionalData
    }
  })
}

export const sendAddToCartEvent = (professionalData, value, variant = 'PRINCIPAL') => {
  clearEcommerceObject()

  if (!Array.isArray(professionalData)) {
    professionalData = [professionalData]
  }

  dataLayer.push({
    event: 'add_to_cart',
    domain,
    ecommerce: {
      variant: getSearchVariant(variant),
      currency,
      value,
      items: professionalData
    }
  })
}

export const sendBeginCheckoutEvent = (checkoutData, value, variant = 'PRINCIPAL') => {
  clearEcommerceObject()

  if (!Array.isArray(checkoutData)) {
    checkoutData = [checkoutData]
  }

  dataLayer.push({
    event: 'begin_checkout',
    domain: domain,
    ecommerce: {
      variant: variant,
      currency: currency,
      value: value,
      coupon: '',
      items: checkoutData
    }
  })
}

export const sendHomeViewEvent = ({ location, referrer, title, variant = 'PRINCIPAL' }) => {
  clearEcommerceObject()

  dataLayer.push({
    event: 'home_view',
    domain: domain,
    ecommerce: {
      variant: variant,
      location: location,
      referrer: referrer,
      title: title
    }
  })
}

export const sendAddPaymentInfoEvent = (
  checkoutDataForDataLayer,
  value,
  paymentType,
  variant = 'PRINCIPAL'
) => {
  clearEcommerceObject()

  if (!Array.isArray(checkoutDataForDataLayer)) {
    checkoutDataForDataLayer = [checkoutDataForDataLayer]
  }

  dataLayer.push({
    event: 'add_payment_info',
    domain,
    ecommerce: {
      variant: getSearchVariant(variant),
      payment_type: paymentType,
      value,
      items: checkoutDataForDataLayer
    }
  })
}

export const favoriteProfessional = ({
  favoriteEvent,
  professionalId,
  professionalSlug,
  variant
}) => {
  clearEcommerceObject()

  dataLayer.push({
    event: favoriteEvent,
    ecommerce: {
      variant: variant,
      id: professionalId,
      slug: professionalSlug
    }
  })
}

export const sendPurchaseEvent = (data) => {
  clearEcommerceObject()
  dataLayer.push(data)
}

export const sendBeaconIncidentsListEvent = ({ incidentsList, variant = 'PRINCIPAL' }) => {
  clearEcommerceObject()
  dataLayer.push({
    event: 'beacon_click',
    ecommerce: {
      variant: variant,
      incidents: incidentsList
    }
  })
}

export const sendBeaconIncidentEvent = ({ incident, variant = 'PRINCIPAL' }) => {
  clearEcommerceObject()
  dataLayer.push({
    event: 'beacon_incident_click',
    ecommerce: {
      variant: variant,
      incident: incident
    }
  })
}

export const sendSearchOnDemonstrativeFaq = ({ id, slug, query }) => {
  clearEcommerceObject()
  window.dataLayer?.push({
    event: 'search_on_demonstrative_faq',
    domain,
    ecommerce: {
      id,
      slug,
      query
    }
  })
}

export const sendSingleClickPurchase = ({ items, value, variant = 'PRINCIPAL' }) => {
  clearEcommerceObject()

  dataLayer?.push?.({
    event: 'single_click_purchase',
    ecommerce: {
      variant: getSearchVariant(variant),
      currency,
      items,
      value
    }
  })
}

export const sendMultipleScheduling = ({ items, value, variant = 'PRINCIPAL' }) => {
  clearEcommerceObject()

  dataLayer?.push?.({
    event: 'multiple_scheduling_purchase',
    ecommerce: {
      variant: getSearchVariant(variant),
      currency,
      items,
      value
    }
  })
}

export const sendInitialPulseForm = ({ userId }) => {
  clearEcommerceObject()

  dataLayer.push({
    event: 'start_progress_pulse_collect',
    domain,
    user_id_collect: userId
  })
}

export const sendFinishPulseForm = (userId) => {
  clearEcommerceObject()

  dataLayer.push({
    event: 'finish_progress_pulse_collect',
    domain,
    user_id_collect: userId
  })
}

export const sendInitialCheckupForm = (userId) => {
  clearEcommerceObject()

  dataLayer.push({
    event: 'start_recurrent_checkup_collect',
    domain,
    user_id_collect: userId
  })
}

export const sendFinishCheckupForm = (userId) => {
  clearEcommerceObject()

  dataLayer.push({
    event: 'finish_recurrent_checkup_collect',
    domain,
    user_id_collect: userId
  })
}
